import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
	getChosenDate,
	isOpenChosenDateModal,
} from '../../store/selectors/clockReport.selector';
import MobileHeader from '../../components/shared/Header/MobileHeader.component';
import HeaderContainer from '../../components/shared/Header/Header.container';
import colors from '../../config/colors';
import ReportsCalendarContainer from '../../components/shared/ReportsCalendar/ReportsCalendar.container';
import { createStackNavigator } from '@react-navigation/stack';
import DayReportsContainer from './DayReports/DayReports.container';
import { getDocumentTitle } from '../../utils/globals.utils';
import { TouchableHighlight, StyleSheet, View, ScrollView, Platform } from 'react-native';
import ImageIcon from '../../components/shared/Icon/ImageIcon.component';
import getShadowStyle from '../../config/shadow';
import AttendanceStatsCard from '../HomePage/SubComponents/AttendanceStatsCard';
import Typography from '../../components/shared/Typography/Typography.component';
import { i18nService } from '../../services/i18n.service';
import { MonthAttendanceResponse } from '../../services/hooks/useMonthAttendance.hook';

const Stack = createStackNavigator();

interface Props {
	navigation: any;
	monthlyAttendanceData: MonthAttendanceResponse | null;
}

const CalendarAttendanceReports = ({ navigation, monthlyAttendanceData}: Props) => {
	const isFirstInit = useRef(true);
	const showModal = useSelector(isOpenChosenDateModal);

	useEffect(() => {
		if (!isFirstInit.current && showModal) {
			navigation.navigate('chosenDate');
		}

		isFirstInit.current = false;
	}, [showModal]);

	return (
		<>
			<Stack.Navigator
				mode='modal'
				screenOptions={{ headerShown: false ,	
					title: getDocumentTitle('calendar'),
				}}
			>
				<Stack.Screen
					name='calendar'
					component={() => (

						<>
							<HeaderContainer
								containerStyle={{
									backgroundColor: colors.white,
								}}
								navigation={navigation}
								component={MobileHeader}
							/>
							<ScrollView
								style={styles.scrollContainer}
								contentContainerStyle={styles.scrollContent}
							>
								<View style={styles.calendarCard}>
									<View style={styles.clockHeader}>
										<ImageIcon name="clockInLogo" width={108} height={30} />
										<Typography color="primaryDarkBlue" font="medium" size={14}>
											{i18nService.translate('attendanceReports')}
										</Typography>
									</View>
									<ReportsCalendarContainer />
								</View>
								<AttendanceStatsCard
									showButton={false}
									monthlyAttendanceData={
										monthlyAttendanceData
									}
								/>
							</ScrollView>
						</>
					)}
				/>
				<Stack.Screen
					name='chosenDate'
					component={() => (
						<DayReportsContainer navigation={navigation} />
					)}
				/>
			</Stack.Navigator>
		</>
	);
};

const styles = StyleSheet.create({
	fabButton: {
		borderRadius: 30,
		width: 40,
		height: 40,
		margin: 10,
		...getShadowStyle(20, 'rgb(59, 112, 164)'),
	},
	scrollContainer: {
		flex: 1,
		padding: 16
	},
	scrollContent: {
		padding: 16,
		...Platform.select({ web: { gap: 16 } }),
	},
	clockHeader: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: 16,
	},
	calendarCard: {
		borderRadius: 8,
		padding: 16,
		backgroundColor: colors.white,
		...Platform.select({ ios: { marginBottom: 16 }, android: { marginBottom: 16 } }),
		overflow: 'hidden',
		...Platform.select({
			web: { boxShadow: '2px 2px 16px 0 rgba(0, 0, 0, 0.04)' },
			ios: { shadowColor: '#000', shadowOffset: { width: 2, height: 2 }, shadowOpacity: 0.04, shadowRadius: 16 },
			android: { elevation: 2 },
		}),
	},
});



export default CalendarAttendanceReports;
